import React, { useState, useEffect } from 'react';
// Script Path & Filename: frontend/src/components/DatabaseAdmin.jsx
import { DynamicTableViewer } from './DynamicTableViewer';
import { UIConfigModal } from './UIConfigModal';

export const DatabaseAdmin = ({ token }) => {
    const [tables, setTables] = useState([]);
    const [selectedTable, setSelectedTable] = useState('');
    const [uiConfig, setUiConfig] = useState([]);
    const [missingConfig, setMissingConfig] = useState(null);

    const fetchCoreData = async () => {
        const headers = { 'Authorization': `Bearer ${token}` };
        try {
            const tblRes = await fetch('/api/data/schema/tables', { headers });
            if (tblRes.ok) {
                const tblData = await tblRes.json();
                setTables(tblData.map(t => t.TableName));
                if (tblData.length > 0 && !selectedTable) {
                    setSelectedTable(tblData[0].TableName);
                }
            }
            
            const cfgRes = await fetch('/api/data/uiconfig', { headers });
            if (cfgRes.ok) {
                setUiConfig(await cfgRes.json());
            }
        } catch (err) {
            console.error("Failed to load schema context", err);
        }
    };

    useEffect(() => {
        fetchCoreData();
    }, [token]);

    return (
        <div className="flex flex-col h-full space-y-4">
            <div className="flex items-center space-x-4 bg-slate-800 p-4 rounded-lg border border-slate-700 shrink-0">
                <span className="material-symbols-outlined text-slate-400">table_rows</span>
                <div className="flex-1 max-w-md">
                    <select 
                        value={selectedTable} 
                        onChange={e => setSelectedTable(e.target.value)}
                        className="w-full bg-slate-900 border border-slate-600 rounded px-4 py-2 text-white outline-none focus:border-blue-500 transition-colors cursor-pointer"
                    >
                        {tables.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                </div>
                <div className="text-sm text-slate-500">
                    Select a database table to inspect data and configure relational presentation mappings.
                </div>
            </div>
            
            <div className="flex-1 overflow-hidden min-h-0 bg-slate-800 rounded-lg border border-slate-700 flex flex-col">
                {selectedTable ? (
                    <DynamicTableViewer 
                        targetTable={selectedTable} 
                        token={token} 
                        uiConfig={uiConfig} 
                        onMissingConfig={setMissingConfig} 
                    />
                ) : (
                    <div className="flex-1 flex items-center justify-center text-slate-500">
                        Loading database schema...
                    </div>
                )}
            </div>

            {missingConfig && (
                <UIConfigModal 
                    token={token}
                    schema={missingConfig.schema}
                    table={missingConfig.table}
                    onClose={() => setMissingConfig(null)}
                    onSuccess={() => { setMissingConfig(null); fetchCoreData(); }}
                />
            )}
        </div>
    );
};